import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useMemo, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage'; // @ts-expect-error untyped dependency

import FormattedDuration from 'I18n/components/FormattedDuration';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton'; // @ts-expect-error untyped dependency

import { getAppShortlink, getConnectedAppsUrl } from '../../../utils/urls'; // @ts-expect-error untyped dependency

import { UnreviewableReasons } from '../../../constants/Reviewability';
// @ts-expect-error untyped dependency
import ExistingPortalReviewsPanel from './ExistingPortalReviewsPanel'; // @ts-expect-error untyped dependency

import { resetReviewSubmitted } from '../../../actions/ReviewsActions'; // @ts-expect-error untyped dependency

import { getReviewSubmitted } from '../../../selectors/reviews';
export default function WriteReviewButton({
  className,
  disabled = false,
  offeringId,
  onClick,
  reviewability,
  size = 'sm',
  tooltipPlacement = 'left',
  use = 'tertiary'
}) {
  const {
    pathname
  } = useLocation();
  const dispatch = useDispatch();
  const reviewSubmitted = useSelector(getReviewSubmitted);
  const [panelOpen, setPanelOpen] = useState(false);
  const isReviewable = reviewability.isReviewable();
  const reason = reviewability.getUnreviewableReason();
  useEffect(() => {
    return () => {
      dispatch(resetReviewSubmitted());
    };
  }, [dispatch]);
  const tooltipMessage = useMemo(() => {
    if (reviewSubmitted) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.reviews.write.unreviewable.reviewSubmitted"
      });
    }

    const reasonTextPath = `appMarketplace.detail.reviews.write.unreviewable.${reason}`;

    switch (reason) {
      case UnreviewableReasons.NOT_INSTALLED:
        {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: `${reasonTextPath}_jsx`,
            options: {
              external: true,
              href: getConnectedAppsUrl(true)
            },
            elements: {
              Link: UILink
            }
          });
        }

      case UnreviewableReasons.UNINSTALLED:
        {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: `${reasonTextPath}_jsx`,
            elements: {
              UninstallWindow: /*#__PURE__*/_jsx(FormattedDuration, {
                from: 1,
                to: reviewability.get('maxMillisAfterUninstall')
              })
            }
          });
        }

      case UnreviewableReasons.LIMIT_REACHED:
        {
          return /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: `${reasonTextPath}_jsx`,
            options: {
              onClick: () => setPanelOpen(true)
            },
            elements: {
              Link: UILink
            }
          });
        }

      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: reasonTextPath
        });
    }
  }, [reviewability, reviewSubmitted, reason]);

  if (reason === UnreviewableReasons.PUBLIC_USER) {
    return /*#__PURE__*/_jsx(UIButton, {
      className: className,
      href: getAppShortlink(`${pathname}/write-review`),
      use: use,
      size: size,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.reviews.write.button"
      })
    });
  }

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UITooltip, {
      title: tooltipMessage,
      disabled: reviewSubmitted ? false : isReviewable,
      placement: tooltipPlacement,
      children: /*#__PURE__*/_jsx(UIButton, {
        className: className,
        onClick: onClick,
        use: use,
        size: size,
        disabled: reviewSubmitted ? true : disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.reviews.write.button"
        })
      })
    }), panelOpen && /*#__PURE__*/_jsx(ExistingPortalReviewsPanel, {
      offeringId: offeringId,
      onClose: () => setPanelOpen(false),
      reviewability: reviewability
    })]
  });
}